module.exports = __webpack_public_path__ + "static/media/forecast.9fc81061.svg";